import { primaryAppPath } from "./appNavigation";

export const SIGN_IN_PATH = "/register?auth=sign-in";

export const safeReturnToPath = (value) => {
  if (!value || !value.startsWith('/') || value.startsWith('//')) {
    return null;
  }

  return value;
};

// Post-auth navigation for return_to targets. /start-checkout is a Rails
// endpoint, not an SPA route: it needs a full-page navigation so the request
// carries the fresh session cookie and can 303 straight to Stripe Checkout.
export const navigateToPostAuthPath = (navigate, path) => {
  const target = path || primaryAppPath();

  if (target.startsWith('/start-checkout')) {
    window.location.assign(target);
    return;
  }

  navigate(target);
};

export const registerShouldStartWithSignIn = ({ search = '', uuidHasAccount = false } = {}) => (
  !!uuidHasAccount || new URLSearchParams(search).get('auth') === 'sign-in'
);

export const existingAccountSignInPath = ({
  pathname = '/plan-selection',
  search = '',
  hash = '',
} = {}) => {
  const returnTo = safeReturnToPath(`${pathname}${search}${hash}`) || '/plan-selection';
  const params = new URLSearchParams({
    auth: 'sign-in',
    return_to: returnTo,
  });

  return `/register?${params.toString()}`;
};
